// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__SG1ga","content":"styles_content__49zQY","projects":"styles_projects__xFVTE"};